import React, { useEffect, useState } from "react";
import { Typography, Row, Col } from "antd";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useUserBranches } from "../../../hooks/accessControl";
import { getLocalPhoneNumber } from "../../../components/util/helpers";

const { Title, Text } = Typography;

const DiaryHeader = (props) => {
  const { currentDate, selectedClientName, clientCategory, patient } = props;
  const userBranches = useUserBranches();
  const [branch, setBranch] = useState({});
  useEffect(() => {
    const branch =
      patient && userBranches.filter((i) => i.id === patient.branch_id)[0];
    if (branch) {
      setBranch(branch);
    }
  }, [userBranches, patient]);
  const avatar_url = useSelector(
    (state) => state.organization.details.avatar_url
  );
  const organizationName = useSelector(
    (state) => state.organization.details.name
  );
  const phone =
    branch && branch.phone_number
      ? getLocalPhoneNumber(branch.phone_number)
      : null;
  const mobile =
    branch && branch.mobile_number
      ? getLocalPhoneNumber(branch.mobile_number)
      : null;
  const fax =
    branch && branch.fax_number ? getLocalPhoneNumber(branch.fax_number) : null;
  const address =
    branch && branch.address
      ? [
          branch.address.city,
          branch.address.street,
          branch.address.house_number,
        ].join(", ")
      : null;
  // {`${selectedClientName}, ${clientCategory}`}
  return (
    <div className="diary_header">
      <Row>
        <Col span={10}>
          <div className="item_container">
            <Text>{`מאת: ${organizationName} - ${branch.name}`}</Text>
            <Text style={{ fontWeight: "bold", fontSize: "1.25em" }}>
              {<FormattedMessage id="app.work_diary_print.to" />}{" "}
              {`${selectedClientName}`}
            </Text>
            <Title level={4} style={{ margin: 0 }}>
              {<FormattedMessage id="app.work_diary_print.title" />}{" "}
              {moment(currentDate).format("MM/YYYY")}
            </Title>
          </div>
        </Col>
        <Col span={4}>
          {avatar_url ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={avatar_url}
                alt={"logo"}
                style={{ height: "60px", objectFit: "contain" }}
              />
            </div>
          ) : null}
        </Col>
        <Col span={10}>
          <div className="branch_details">
            {phone && <Text>{`טלפון: ${phone}`}</Text>}
            {mobile && <Text>{`סלולארי: ${mobile}`}</Text>}
            {fax && <Text>{`פקס: ${fax}`}</Text>}
            {address && <Text>{`כתובת: ${address}`}</Text>}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DiaryHeader;
